var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTablerphone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.33333 2.66699H6L7.33333 6.00033L5.66667 7.00033C6.38064 8.44801 7.55231 9.61969 9 10.3337L10 8.66699L13.3333 10.0003V12.667C13.3333 13.0206 13.1929 13.3598 12.9428 13.6098C12.6928 13.8598 12.3536 14.0003 12 14.0003C9.39951 13.8423 6.94677 12.738 5.10455 10.8958C3.26234 9.05356 2.15803 6.60082 2 4.00033C2 3.6467 2.14048 3.30756 2.39052 3.05752C2.64057 2.80747 2.97971 2.66699 3.33333 2.66699Z",
    stroke: "#717171",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTablerphone);
export default __webpack_public_path__ + "static/media/tablerphone.cee98968cbae9164baf2a4d840ccedfe.svg";
export { ForwardRef as ReactComponent };